// extracted by mini-css-extract-plugin
module.exports = {"gridSpacingLarge":"_2qo7-Co8","gridSpacingMedium":"_1kldBuJ3","errorClass":"_3D0S6haC"};